import type { FunctionComponent } from 'react'
import { MessagePage } from './MessagePage'

export const Error404Page: FunctionComponent = () => (
	<MessagePage title="This page could not be found" returnLinkText="Go back to homepage" />
)
